import React from "react";
import { PlainModalOverlay } from "../../UI/Modal/Modal";
import { ButtonSubmitGreen } from "../../UI/Buttons/Buttons";
import { FaLongArrowAltLeft } from "react-icons/fa";
import Alert from '@mui/material/Alert';
import ResumeSelectList from "../ResumeSelectList";

const styles = {
    modalInner: {
        width: '100%',
        textAlign: 'center'
    }
};

const ResumeSelectorModal = React.memo(({
    closeModalsAndReset,
    allResumes,
    activeResIndex,
    handleResumeSelect,
    handleResumePreview,
    actionString,
    handleGenerate
}) => {
    return (
        <PlainModalOverlay>
            <div style={styles.modalInner}>
                <div className='prev-page' onClick={closeModalsAndReset}>
                    <FaLongArrowAltLeft />
                </div>
                <h4>Choose a resume for me to optimize your {actionString}, together with this job's real data.</h4>
                <Alert sx={{padding: '0 5px', fontSize: '.7rem'}} severity="warning">Using the "Get Resume" button on each job to optimize your resume per-job gives your application materials more relevance and hence, gives you a surer chance.</Alert>

                <ResumeSelectList
                    label="Select Resume"
                    resumes={allResumes}
                    selectedIndex={activeResIndex}
                    onSelectResume={(idx) => handleResumeSelect(idx)}
                    onPreviewResume={handleResumePreview}
                />

                <div style={{width: '100%'}}>
                    <ButtonSubmitGreen onClick={handleGenerate} >Get {actionString}</ButtonSubmitGreen>
                </div>

            </div>
        </PlainModalOverlay>
    );
});

export default ResumeSelectorModal;